import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const GlassCard = ({ item, onOpen }) => {
  // Estados para manejar el cambio de variante e imagen dentro de la tarjeta
  const [activeVariant, setActiveVariant] = useState(null);
  const [currentImg, setCurrentImg] = useState(0);

  useEffect(() => {
    if (item.variants?.length > 0) {
      setActiveVariant(item.variants[0]);
      setCurrentImg(0);
    }
  }, [item]);

  // Imagen a mostrar: Prioriza la variante seleccionada, luego la imagen base del item
  const mainImage = activeVariant?.images?.[currentImg] || item.image || null;

  return (
    <div 
      className="bg-white/40 backdrop-blur-md border border-white/60 p-5 rounded-[2.5rem] shadow-xl shadow-gray-200/50 hover:border-[#a6192e]/30 transition-all group flex flex-col h-full overflow-visible"
    >
      {/* CONTENEDOR DE IMAGEN */}
      <div className="relative overflow-hidden rounded-[2rem] mb-5 aspect-square bg-gray-50 border border-gray-100 shadow-inner">
        {mainImage ? (
          <motion.img 
            key={mainImage} // Para animar el cambio de imagen
            initial={{ opacity: 0.8 }}
            animate={{ opacity: 1 }}
            src={mainImage} 
            alt={item.name} 
            className="w-full h-full object-contain mix-blend-multiply group-hover:scale-105 transition-transform duration-500 p-4" 
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-slate-300 italic text-[10px] tracking-widest uppercase p-6 text-center">
            <svg className="w-8 h-8 mb-2 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
            Sin Previsualización
          </div>
        )}
        
        {/* BADGE DE CATEGORÍA (SI EXISTE) */}
        {item.category && (
          <div className="absolute top-4 left-4 bg-[#a6192e] text-white text-[8px] font-black px-3 py-1 rounded-full uppercase tracking-widest shadow-lg italic">
            {item.category}
          </div>
        )}
      </div>

      {/* TEXTO: TÍTULO Y DESCRIPCIÓN (CORREGIDO PARA QUE NO SE CORTE) */}
      <div className="px-1 overflow-visible">
        <h3 className="text-slate-900 font-black text-xl mb-2 italic uppercase tracking-tighter leading-tight break-words whitespace-normal group-hover:text-[#a6192e] transition-colors">
          {item.name}
        </h3>
        <p className="text-slate-500 text-xs mb-5 line-clamp-2 italic leading-relaxed">
          {item.description || "Explora los detalles técnicos de este insumo industrial exclusivo."}
        </p>
      </div>

      {/* SELECTOR DE VARIANTES (INTERACTIVO) */}
      {item.variants?.length > 1 && (
        <div className="flex gap-2 mb-6 px-1 overflow-x-auto no-scrollbar pb-1">
          {item.variants.map((v, idx) => (
            <button
              key={idx}
              onClick={(e) => {
                e.stopPropagation(); // Evita que abra el modal al cambiar color
                setActiveVariant(v);
                setCurrentImg(0);
              }}
              className={`text-[9px] px-3 py-1.5 rounded-full border transition-all whitespace-nowrap font-black tracking-widest uppercase italic ${
                activeVariant?.color === v.color 
                ? 'border-[#a6192e] bg-[#a6192e] text-white shadow-lg shadow-red-100' 
                : 'border-gray-200 bg-gray-50 text-slate-400 hover:border-[#a6192e]/40'
              }`}
            >
              {v.color}
            </button>
          ))}
        </div>
      )}

      {/* BOTÓN DE ACCIÓN */}
      <div className="mt-auto">
        <button 
          onClick={onOpen}
          className="w-full py-4 bg-[#a6192e] hover:bg-[#8e1527] text-white font-black text-[10px] tracking-[0.2em] rounded-2xl transition-all shadow-xl shadow-red-100 active:scale-95 uppercase italic"
        >
          Conocer más
        </button>
      </div>
    </div>
  );
};

export default GlassCard;